module.exports = __webpack_public_path__ + "img/depmap_svg_V139.85942831.svg";